import { Cart } from './@types';

// fetch cart
export const fetchCart = async (): Promise<Cart> => {
  const response = await fetch('/cart.js');
  return await response.json();
};

export const updateIconCount = (cart: Cart, cartClassName: string | undefined): void => {
  if (!cartClassName) return;
  const cartCount = document.querySelector(`.${cartClassName}`);
  if (cartCount) {
    cartCount.innerHTML = cart.item_count.toString();
  }
};
